import { render } from "./Kvkk.vue?vue&type=template&id=00a6487e&ts=true"
import script from "./Kvkk.vue?vue&type=script&lang=ts"
export * from "./Kvkk.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__